import { createContext } from "react";

export interface DrawerContextValue {
	close: VoidFunction;
}

export const DrawerContext = createContext<undefined | DrawerContextValue>(undefined);
